var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCandadoAbierto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 225 225",
    style: {
      enableBackground: "new 0 0 225 225"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:8.000000e-02;}\n\t.st1{fill:url(#Uni\xF3n_3_00000039098687741897043950000003098382878704643471_);}\n\t.st2{fill:#DFE0E0;}\n\t.st3{fill:#EAEAEA;}\n\t.st4{fill:#CC0000;}\n\t.st5{fill:var(--color-primary);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9065",
    transform: "translate(-1281 2278.157)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8985-2",
    transform: "translate(0 70.999)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Uni\\xF3n_3_00000162345260881863550220000014424956815961974454_",
    gradientUnits: "userSpaceOnUse",
    x1: 1136.295,
    y1: -1979.8279,
    x2: 1136.295,
    y2: -1981.4377,
    gradientTransform: "matrix(109.998 0 0 -60 -123596.6875 -121014.9453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.102
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_3",
    style: {
      fill: "url(#Uni\xF3n_3_00000162345260881863550220000014424956815961974454_)"
    },
    d: "M1356.1-2136.4 c-42.9-8.8-71.1-30.6-71.1-54.9v-25.5c0-3.5,4.6-6.6,11.1-7.4l19.6-2.4v-8.1c0-3.8,5.3-7,12.4-7.5l65.3-4.8l0,0l65.4,4.8 c7.1,0.5,12.4,3.7,12.4,7.5v8.1l19.6,2.4c6.5,0.8,11.1,3.9,11.1,7.4v25.5c0,24.3-28.2,46.1-71.1,54.9l-37.4,7.7l0,0L1356.1-2136.4 z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-escudo",
    transform: "translate(-32.219 -43.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8985",
    transform: "translate(32.219 43.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5907",
    className: "st2",
    d: "M37.2,15.9v26.2L5.5,49.3c-1.7,0.4-3,1.9-3,3.7v52.7c0,45.4,28.7,86.1,72.3,102.5 l37.7,14.3V2.5l-72,9.7C38.6,12.4,37.2,14,37.2,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5908",
    className: "st3",
    d: "M112.5,222.5l37.7-14.3c43.6-16.5,72.3-57.2,72.3-102.5V53c0-1.8-1.3-3.3-3-3.7l-31.7-7.2 V15.9c0-1.9-1.5-3.5-3.4-3.7l-72-9.7L112.5,222.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12782",
    transform: "translate(-324.682 -16.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5970",
    className: "st4",
    d: "M437.4,63.3L437.4,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5971",
    className: "st5",
    d: "M437.8,128.9L437.8,128.9c-3.1-0.2-5.8,2.2-6,5.3c-0.1,2,0.8,3.9,2.5,5 c0.9,0.6,1.2,1.7,0.9,2.8c-0.1,0.2-0.2,0.8-0.2,1.1c-0.5,1.5,0.6,3.6,2.2,3.6h0.5c1.5,0,2.6-2.2,2.2-3.6c-0.1-0.3-0.2-1.3-0.3-1.6 c-0.3-0.9,0-1.9,0.8-2.5c2.1-1.1,3.2-3.6,2.5-6C442.2,130.7,440.2,129.1,437.8,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5972",
    className: "st5",
    d: "M437.4,63.3c-33.1,0-60,26.9-60,60s26.9,60,60,60s60-26.9,60-60l0,0l0,0 C497.4,90.1,470.6,63.3,437.4,63.3z M456.6,157.5h-38c-4.2,0-7.6-3.4-7.6-7.6l0,0v-25.3c0-4.2,3.4-7.6,7.6-7.6v-13.1 c0-10.4,8-19.5,18.4-19.8c10.5-0.3,19.3,7.9,19.6,18.4c0,0.2,0,0.4,0,0.6v2.4c0,1-0.6,1.9-1.5,2.3l-6.5,2.8v-6.9 c0-6-4.3-11.3-10.3-11.8c-6.3-0.6-11.8,4-12.5,10.2c0,0.4-0.1,0.7-0.1,1.1V117h30.8c4.2,0,7.6,3.4,7.6,7.6v25.3 C464.2,154.1,460.9,157.5,456.6,157.5L456.6,157.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCandadoAbierto);
export default __webpack_public_path__ + "static/media/ico-candado-abierto.119c718f7c567d085588357dcce3dfe1.svg";
export { ForwardRef as ReactComponent };